import Button from "heroic-ui-library/dist/components/Button";
import { useState } from "react";
import toast from "react-hot-toast";
import isPhone from "validator/lib/isMobilePhone";
import { apiClient } from "../../api/api-client";
import Loading from "react-loading";
import { useNavigate } from "react-router";
import LoginWithGoogle from "./LoginWithGoogle";
import { getCountryCode } from "../../lib";
import PINField from "./PINField";
import PhoneNumberInput from "../../components/PhoneNumber";

type Props = {
  phoneNumber: string;
  countryCode: string;
  hideChildCode: boolean;
  loginType: "child_code" | "otp";
  setloginType: (value: "child_code" | "otp") => void;
  setPhoneNumber: (value: string) => void;
  setCountryCode: (value: string) => void;
  onSignUp: () => void;
  onForgot: () => void;
};

export default function LoginUsingOTP({
  onSignUp,
  onForgot,
  setPhoneNumber,
  setCountryCode,
  setloginType,
  loginType,
  phoneNumber,
  countryCode,
  hideChildCode,
}: Props) {
  const [pinCode, setPinCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const nav = useNavigate();

  const login = async () => {
    console.log("Here", pinCode);
    if (pinCode == "") return toast.error("Please enter pin");

    const completePhone = countryCode + phoneNumber.replace(/\D/g, "");
    const isPhoneValid = isPhone(completePhone, ["en-US", "en-IN"]);

    if (!isPhoneValid) return toast.error("Invalid Phone Number");

    setIsLoading(true);

    try {
      const response = await apiClient.loginParent(completePhone, pinCode);
      setIsLoading(false);

      if (response?.state != 200) {
        if (response?.if_set_pin == 0) {
          toast.error("Please set your pin");
          onForgot();
        } else toast.error(response.error);
      }

      if (response?.redirect) {
        const url = new URL(response.redirect);
        nav(url.pathname + url.search);
      }
    } catch (error) {
      toast.error((error as any).message);
    }

    setIsLoading(false);
  };

  return (
    <div>
      <h1 className="top-heading text-center mb-3">Login</h1>
      {!hideChildCode && (
        <>
          <div className="flex justify-center items-center mb-3">
            <div className="border-t-2 border-dotted border-gray-400 flex-1" />
            <div className="divider-text text-[1.2rem] font-acme px-3">
              Log in with
            </div>
            <div className="border-t-2 border-dotted border-gray-400 flex-1" />
          </div>
          <div className="flex space-x-4">
            <Button
              onClick={() => setloginType("child_code")}
              className="submit-btn"
              label="Child Code"
              btnType={loginType == "child_code" ? "orange" : "green"}
            />
            <Button
              onClick={() => setloginType("otp")}
              className="submit-btn"
              label="Phone Number"
              btnType={loginType == "otp" ? "orange" : "green"}
            />
          </div>
        </>
      )}
      <div className="space-y-4 mt-4 mb-4 flex flex-col">
        <div className="flex w-full items-center space-x-4">
          {getCountryCode() != "US" && (
            <select
              className="hl-input"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              <option value="+1">US (+1)</option>
              <option value="+91">IN (+91)</option>
            </select>
          )}
          <PhoneNumberInput
            value={phoneNumber}
            required
            onChange={setPhoneNumber}
            countryCode={countryCode == "+1" ? "US" : "IN"}
          />
        </div>
        <div>
          <PINField pinCode={pinCode} setPinCode={setPinCode} />
        </div>
        {!isLoading && (
          <Button
            onClick={login}
            btnType="green"
            className="submit-btn"
            label="Login"
          />
        )}
        {isLoading && (
          <div className="w-full items-center justify-center flex">
            <Loading color="#002356" type="spin" />
          </div>
        )}
        <span className="font-acme text-2xl">
          Forgot PIN?{" "}
          <span
            onClick={onForgot}
            className=" text-blue-600 underline cursor-pointer"
          >
            Click Here
          </span>
        </span>
        <span className="font-acme text-2xl">
          Don't have an account?{" "}
          <span
            onClick={onSignUp}
            className=" text-blue-600 underline cursor-pointer"
          >
            Sign Up here
          </span>
        </span>
        <LoginWithGoogle />
      </div>
    </div>
  );
}
